
export default {
  data () {
    return {
      columns: [
        {
          label: '账单号',
          prop: 'feeNo',
          width: '220px'
        },
        {
          label: '结算客户',
          prop: 'payCustomerName',
          width: '220px'
        },
        {
          label: '仓库名称',
          prop: 'organizationName',
          width: '220px'
        },
        {
          label: '分成金额(元)',
          prop: 'divideFee',
          width: '150px'
        },
        {
          label: '仓库分成比例(%)',
          prop: 'orgDivideFeeProport',
          width: '150px'
        },
        {
          label: '仓库分成金额(元)',
          prop: 'orgDivideFee',
          width: '150px'
        },
        {
          label: '平台分成比例(%)',
          prop: 'platformDivideFeeProport',
          width: '150px'
        },
        {
          label: '平台分成金额(元)',
          prop: 'platformDivideFee',
          width: '150px'
        },
        {
          label: '分成状态',
          prop: 'divideStatus',
          width: '120px'
        },
        {
          label: '分成人',
          prop: 'dividePerson',
          width: '120px'
        },
        {
          label: '分成时间',
          prop: 'divideTime',
          width: '120px'
        }
      ]
    }
  }
}
